import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 7 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m1.73 5.34 4.074 4.073q.208.207.212.522a.7.7 0 0 1-.212.532.72.72 0 0 1-.527.217.72.72 0 0 1-.527-.217L.256 5.972A.83.83 0 0 1 0 5.34q0-.18.058-.337a.8.8 0 0 1 .198-.296L4.75.213A.73.73 0 0 1 5.272 0a.7.7 0 0 1 .532.213q.217.217.217.527a.72.72 0 0 1-.217.527z"
    }, null, -1)
  ]))]))
}
export default { render: render }